import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGLAssignmentMaster extends Layout {
    panelGLAssign: Panel;
    sourceGlAssignment: DataSource;
    switchAllowForRateExceptions: Switch;
    textboxDescription: Textbox;
    textboxGlaCode: Textbox;
    textboxRevCalcPriority: Textbox;
    textboxShortDescription: Textbox;
}
